module.exports = __webpack_public_path__ + "static/media/VerticalLine.0f0fe46c.svg";